<template>
  <div id="form-slideshow-add">
    <CRow class="mt-4">
      <CCol md="10">
        <CCard style="border-radius: unset!important;" @click.stop="clickCard">
          <CCardHeader style="border-radius: unset!important;position: unset!important;" color="light"
                       class="d-inline-flex justify-content-between align-items-center">
            <div>
              <strong style="font-size: 18px;"> Nội dung trình diễn </strong>
            </div>
            <div>
              <CButton color="secondary" class="text-right" v-c-tooltip.hover="'Thêm nội dung'"
                       @click.prevent="submitActionEditor(actionEditor.ADD_LAYER)">
                <i class="fa fa-plus"></i>&nbsp;
              </CButton>&nbsp;&nbsp;
              <CButton color="secondary" class="text-right" v-c-tooltip.click="'Xóa'"
                       :style="isDisabledRemoveLayer ? 'cursor:no-drop;pointer-events:none;background: rgb(216, 220, 224);color: rgb(159, 167, 179);' : ''"
                       @click="removeLayer()">
                <i class="fa fa-trash"></i>&nbsp;
              </CButton>&nbsp;&nbsp;
              <CButton color="secondary"
                       :style="items.length <= 0 ? 'cursor:no-drop;pointer-events:none;background: rgb(216, 220, 224);color: rgb(159, 167, 179);' : ''"
                       class="text-right"
                       v-c-tooltip.hover="'Xem trước'" @click="previewSlideShow()">
                <i class="fa fa-eye"></i>&nbsp;
              </CButton>&nbsp;&nbsp;
            </div>
          </CCardHeader>
          <CCardBody style="padding: unset!important; height: 75vh;position: relative" class="vs-editor root-editor"
                     ref="cardBody">
            <div class="vs-editor-canvas">
              <template>
                <Draggable v-for="(each) of items.slice().reverse()" :key="each.id" :item="each"
                           @active:layer="activeElementLayerDraggable"/>
              </template>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="2">
        <SlideShowEditor :items="items" :action="actionSlideShow" :size="sizeDesign" :itemSelected="itemSelectedEditor"
                         :previewId="idPreview"
                         @choose:layer="chooseLayerEditor" @active:layer="activeLayerEditor"
                         @change:layer="changeLayerEditor"
                         @remove:layer="removeLayerEditor" @loading="loadingLayerEditor"/>
      </CCol>
    </CRow>
    <SlideShowModal v-if="isShowModalChooseLayer" :items="items" :type-layer="typeLayer"
                    @update:show="changeShowModal" @item:selected="itemLayerSelected"/>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>
<script>

import SlideShowEditor from "@/views/slide_show/SlideShowEditor";
import {ACCESS_TOKEN_NAME, ActionEditor, TypeChooseLayer, TypePlayList} from '../../constant';
import BaseFormLoading from "@/views/base/BaseFormLoading";
import SlideShowModal from "@/views/slide_show/SlideShowModal";
import Draggable from "@/views/slide_show/Dragable";

export default {
  name: 'SlideShowAdd',
  components: {Draggable, SlideShowModal, BaseFormLoading, SlideShowEditor},
  data: function () {
    return {
      isDisabledRemoveLayer: true,
      sizeDesign: {},
      loading: {value: false},
      actionEditor: ActionEditor,
      typeChooseLayer: TypeChooseLayer,
      isShowModalChooseLayer: false,
      typeLayer: null,
      items: [],
      actionSlideShow: 0,
      itemSelectedEditor: null,
      idPreview: null
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.getDimensions();
    window.addEventListener('resize', this.getDimensions);
  },
  methods: {
    getDimensions() {
      const {width, height} = this.$refs.cardBody.getBoundingClientRect();
      this.sizeDesign = {
        width: width,
        height: height,
      }
    },
    activeElementLayerDraggable(item) {
      this.items.map((each, index) => {
        if (each.id != item.id) {
          each.active = false;
        } else {
          each.active = true;
          this.itemSelectedEditor = index;
          this.actionSlideShow = this.actionEditor.EDITOR_LAYER;
          this.isDisabledRemoveLayer = false;
        }
      })
    },
    clickCard(e) {
      // eslint-disable-next-line no-undef
      if ($(e.target).is('div.yoyoo-ddr') || $(e.target).parents().is('div.yoyoo-ddr') || $(e.target).is('button') || $(e.target).is('strong')) {
        return false;
      }
      this.items.map((each) => each.active = false);
      this.actionSlideShow = this.actionEditor.LAYOUT_SETTING;
      this.isDisabledRemoveLayer = true;
    },
    submitActionEditor(type) {
      var that = this;
      setTimeout(() => {
        that.actionSlideShow = type;
      }, 100)
    },
    removeLayer() {
      this.items.map((each, index) => {
        if (index === this.itemSelectedEditor) {
          this.items.splice(index, 1);
          this.actionSlideShow = this.actionEditor.LAYOUT_SETTING;
          this.isDisabledRemoveLayer = true;
        }
      })
    },
    previewSlideShow() {
      this.loading.value = true;
      let that = this;
      var items = [];
      this.items.map(each => {
        var item = Object.assign({}, each);
        delete item.extractData;
        var _extractData = each.extractData;
        item.active = false;
        item.extractData = {
          id: _extractData.id ? _extractData.id : null,
          typeLayer: _extractData.typeLayer,
          videoId: _extractData.videoId ? _extractData.videoId : null,
          sourceIds: _extractData.sourceIds ? _extractData.sourceIds : null
        }
        items.push(item);
      })
      var objDataRequest = {
        widthDesign: that.sizeDesign.width,
        heightDesign: that.sizeDesign.height,
        draggableModels: items
      };
      var _urlAPI = '/slide_show_preview/add'
      if (this.idPreview) {
        objDataRequest.idPreview = this.idPreview;
        _urlAPI = '/slide_show_preview/update';
      }
      this.$helper.loadDataSource({
        url: _urlAPI,
        dataSubmit: function () {
          return objDataRequest;
        },
        ignoreDefaultData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            if (that.idPreview == null) {
              that.idPreview = response.data.data;
            }
            var width = window.outerWidth;
            var height = window.outerHeight;
            var keyAES = that.$helper.randomDataWithLength(20);
            var code = that.$helper.encodeAES(encodeURI(localStorage.getItem(ACCESS_TOKEN_NAME)), keyAES);
            if (code) {
              that.loading.value = false;
              window.open(`${process.env.PREVIEW_SLIDESHOW_ADDRESS}/preview.html?id=${that.idPreview}&code=${encodeURIComponent(code)}&k=${encodeURIComponent(btoa(keyAES))}`, "popUpWindow",
                  `height=${height},width=${width},left=0,top=0,fullscreen=yes,resizable=yes,scrollbars=no,toolbar=no,menubar=no,location=no,directories=no, status=yes`)
            }
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    chooseLayerEditor(value) {
      this.typeLayer = value.type;
      this.isShowModalChooseLayer = true;
    },
    activeLayerEditor(id) {
      if (this.items && this.items.length > 0 && id) {
        this.items.find((each, index) => {
          if (each.id === id) {
            each.active = true;
            this.itemSelectedEditor = index;
            this.actionSlideShow = this.actionEditor.EDITOR_LAYER;
          }
        })
      }
    },
    removeLayerEditor(id) {
      if (this.items && this.items.length > 0 && id) {
        this.items.map((each, index) => {
          if (each.id === id) {
            this.items.splice(index, 1);
            this.actionSlideShow = this.actionEditor.LAYOUT_SETTING;
          }
        })
      }
    },
    loadingLayerEditor(value) {
      this.loading.value = value;
    },
    changeLayerEditor() {
    },
    changeShowModal(value) {
      this.isShowModalChooseLayer = value;
    },
    async itemLayerSelected(value) {
      this.loading.value = true;
      var width = this.$refs.cardBody.clientWidth;
      var height = this.$refs.cardBody.clientHeight;
      var center = {x: width / 2, y: height / 2};
      if (value && (value.typeLayer != null && value.typeLayer != undefined)) {
        this.item = {
          id: new Date().getTime(),
          active: true,
          draggable: true,
          rotatable: false,
          extractData: value,
        }
        switch (value.typeLayer) {
          case this.typeChooseLayer.TEXT : {
            this.item.attr = {
              direction: 'left',
              color: '#000000',
              fontSize: '20',
              fontWeight: '400',
              background: 'rgba(255,255,255,0)',
              letterSpacing: 0,
              font: 'Arial',
              lineHeight: '30',
              textAlign: 'center',
              fontStyle: 'normal',
              textDecoration: 'none',
              speed: 50
            };
            this.item.acceptRatio = false;
            this.item.minWidth = 300;
            this.item.minHeight = 58;
            this.item.transform = {
              x: (width - (width / 2)) / 2,
              y: center.y,
              width: width / 2,
              height: 58,
              rotation: 0
            };
            break;
          }
          case this.typeChooseLayer.IMAGE : {
            this.item.attr = {}
            this.item.acceptRatio = false;
            await this.getMeta(value.url, 0).then(img => {
              var imgWidth = img.width;
              var imgHeight = img.height;
              var maxWidth = width / 2;
              var maxHeight = height / 2;
              var ratio = this.calculateAspectRatioFit(imgWidth, imgHeight, maxWidth, maxHeight);
              this.item.transform = {
                x: ((width - (imgWidth * ratio)) / 2),
                y: ((height - (imgHeight * ratio)) / 2),
                width: imgWidth * ratio,
                height: imgHeight * ratio,
                rotation: 0
              };
            })
            break;
          }
          case this.typeChooseLayer.VIDEO : {
            this.item.attr = {
              isMuted: false
            }
            this.item.acceptRatio = false;
            await this.getMeta(value.urlThumbnail, 0).then(video => {
              var imgWidth = video.width;
              var imgHeight = video.height;
              var maxWidth = width / 2;
              var maxHeight = height / 2;
              var ratio = this.calculateAspectRatioFit(imgWidth, imgHeight, maxWidth, maxHeight);
              this.item.transform = {
                x: ((width - (imgWidth * ratio)) / 2),
                y: ((height - (imgHeight * ratio)) / 2),
                width: imgWidth * ratio,
                height: imgHeight * ratio,
                rotation: 0
              };
            })
            break;
          }
          case this.typeChooseLayer.PLAY_LIST : {
            this.item.attr = {
              isMuted: false
            }
            this.item.acceptRatio = false;
            if (value.type === TypePlayList.TEXT_RUN || value.type === TypePlayList.TEXT_NORMAL) { /* Playlist loại văn bản gồm chữ chạy và chữ thường */
              this.item.attr = {
                direction: 'left',
                color: '#000000',
                fontSize: '20',
                fontWeight: '400',
                background: 'rgba(255,255,255,0)',
                letterSpacing: 0,
                font: 'Arial',
                lineHeight: '30',
                textAlign: 'center',
                fontStyle: 'normal',
                textDecoration: 'none'
              };
              this.item.acceptRatio = false;
              this.item.minWidth = 300;
              this.item.minHeight = 58;
              this.item.transform = {
                x: (width - (width / 2)) / 2,
                y: center.y,
                width: width / 2,
                height: 58,
                rotation: 0
              };
            } else if (value.type === TypePlayList.IMAGE || value.type === TypePlayList.VIDEO || value.type === TypePlayList.DOCUMENT) { /* PlayList loại media gồm hình ảnh và video */
              var urlImage = value.playListDetailModels[0].url;
              if (value.type === TypePlayList.VIDEO) {
                urlImage = value.playListDetailModels[0].urlThumbnail;
              } else if (value.type === TypePlayList.DOCUMENT) {
                urlImage = value.playListDetailModels[0].urlImagesDoc[0];
              }
              await this.getMeta(urlImage, 0).then(data => {
                var imgWidth = data.width;
                var imgHeight = data.height;
                var maxWidth = width / 2;
                var maxHeight = height / 2;
                var ratio = this.calculateAspectRatioFit(imgWidth, imgHeight, maxWidth, maxHeight);
                this.item.transform = {
                  x: ((width - (imgWidth * ratio)) / 2),
                  y: ((height - (imgHeight * ratio)) / 2),
                  width: imgWidth * ratio,
                  height: imgHeight * ratio,
                  rotation: 0
                };
              })
            }
            break;
          }
          case this.typeChooseLayer.YOUTUBE : {
            this.item.attr = {
              isMuted: false
            }
            this.item.acceptRatio = false;
            var videoId = this.getVideoIdYoutube("v", value.url);
            var imageThumbnail = `https://img.youtube.com/vi/${videoId}/0.jpg`;
            if (videoId != undefined && videoId !== null) {
              await this.getMeta(imageThumbnail, 0).then(img => {
                var imgWidth = img.width;
                var imgHeight = img.height;
                var maxWidth = width / 2;
                var maxHeight = height / 2;
                var ratio = this.calculateAspectRatioFit(imgWidth, imgHeight, maxWidth, maxHeight);
                this.item.transform = {
                  x: ((width - (imgWidth * ratio)) / 2),
                  y: ((height - (imgHeight * ratio)) / 2),
                  width: imgWidth * ratio,
                  height: imgHeight * ratio,
                  rotation: 0
                };
                this.item.extractData.img = imageThumbnail;
                this.item.extractData.videoId = videoId;
              });
            }
            break;
          }
          case this.typeChooseLayer.RSS : {
            this.item.attr = {
              direction: 'left',
              color: '#000000',
              fontSize: '20',
              fontWeight: '400',
              background: 'rgba(255,255,255,0)',
              letterSpacing: 0,
              font: 'Arial',
              lineHeight: '30',
              textAlign: 'center',
              fontStyle: 'normal',
              textDecoration: 'none',
              speed: 100
            };
            this.item.acceptRatio = false;
            this.item.minWidth = 300;
            this.item.minHeight = 58;
            this.item.transform = {
              x: (width - (width / 2)) / 2,
              y: center.y,
              width: width / 2,
              height: 58,
              rotation: 0
            };
            break;
          }
          case this.typeChooseLayer.STREAM_VTV : {
            this.item.attr = {
              isMuted: false
            }
            this.item.acceptRatio = false;
            await this.getMeta(value.urlThumbnail, 0).then(video => {
              var imgWidth = video.width;
              var imgHeight = video.height;
              var maxWidth = width / 2;
              var maxHeight = height / 2;
              var ratio = this.calculateAspectRatioFit(imgWidth, imgHeight, maxWidth, maxHeight);
              this.item.transform = {
                x: ((width - (imgWidth * ratio)) / 2),
                y: ((height - (imgHeight * ratio)) / 2),
                width: imgWidth * ratio,
                height: imgHeight * ratio,
                rotation: 0
              };
            })
            break;
          }
          case this.typeChooseLayer.DOCUMENT : {
            this.item.attr = {}
            this.item.acceptRatio = false;
            var documentConvert = value.urlDocumentConvert;
            if (documentConvert) {
              var itemsImage = [];
              if (documentConvert.includes(",")) {
                itemsImage = documentConvert.split(",");
              } else {
                itemsImage.push(documentConvert);
              }
              this.item.acceptRatio = false;
              await this.getMeta(itemsImage[0], 0).then(img => {
                var imgWidth = img.width;
                var imgHeight = img.height;
                var maxWidth = width / 2;
                var maxHeight = height / 2;
                var ratio = this.calculateAspectRatioFit(imgWidth, imgHeight, maxWidth, maxHeight);
                this.item.transform = {
                  x: ((width - (imgWidth * ratio)) / 2),
                  y: ((height - (imgHeight * ratio)) / 2),
                  width: imgWidth * ratio,
                  height: imgHeight * ratio,
                  rotation: 0
                };
              })
            }
            this.item.extractData.itemsImage = itemsImage;
          }
        }
        this.items.map(each => each.active = false);
        this.item.isSlideShow = true;
        // this.items.unshift(this.item);
        this.loading.value = false;
        this.items.unshift(this.item);
        this.actionSlideShow = this.actionEditor.EDITOR_LAYER;
        // this.itemSelectedEditor = this.items.length - 1;
        this.itemSelectedEditor = 0;
        this.isDisabledRemoveLayer = false;
      }
    },
    getMeta(url, type) {
      return new Promise((resolve => {
        if (type === 0) {
          var img = new Image();
          img.src = url;
          img.onload = function () {
            resolve({width: this.width, height: this.height});
          }
        } else {
          const video = document.createElement('video');
          video.addEventListener("loadedmetadata", function () {
            resolve({width: this.videoWidth, height: this.videoHeight});
          }, false);
          video.src = url;
        }
      }))
    },
    calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
      var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
      return ratio;
    },
    getVideoIdYoutube(name, url) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  },
  watch: {},
  destroyed() {
    window.removeEventListener('resize', this.getDimensions);
  }
}
</script>

<style scoped>
video {
  object-fit: cover;
}

.vs-editor-canvas {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: rgba(243, 238, 238, 0.91);
  background-image: linear-gradient(0deg, rgba(166, 158, 158, 0.1) 0, transparent 1px), linear-gradient(90deg, rgba(112, 86, 86, 0.1) 1px, transparent 1px);
  background-size: 26px 14px, 26px 14px;
}


.layout-insert-item-column {
  text-align: center;
}

.selected {
  border: 2px solid #118bff;
}

.layout-insert-item-type {
  border-radius: 3px;
  width: 100%;
  height: 140px;
  background: #dcdcdc;
  color: #fff;
  cursor: pointer;
  transition: all ease-in-out .2s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 5px 0px #adb5bd;
}

.layout-insert-item-type img {
  width: 100%;
  height: 100%;
}

.layout-insert-item-type.selected ~ .layout-insert-item-label {
  color: #6458ff;
  font-weight: bold;
}

.layout-insert-item-label {
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}
</style>
<style lang="scss">
#form-slideshow-add {
  .custom-content-modal {
    height: 80vh;
  }

  .nav-link {
    padding: 0.8rem 1rem;
  }

  .folder-local-files {
    width: 100%;
    height: 120px;
    box-shadow: 0 0 5px 0 #adb5bd;

    img {
      width: 100%;
      height: 100%;
    }
  }

  i {
    width: unset !important;
  }


  tr {
    cursor: pointer;
  }

}
</style>
